export default __webpack_public_path__ + "static/tt-norms-bold-a1b1ba9926436ac00631662db7b91b7b.woff2";